import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const EditTLMApi = createAsyncThunk(
  "auth/Edittlm",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.patch(
        apiRoutes.learningMaterialAction(`${data.id}`, 1),
        data
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const EditTLMSlice = createSlice({
  name: "Edit tlm",
  initialState: { result: [], loading: false, error: null, message: "" },
  extraReducers: (builder) => {
    builder.addCase(EditTLMApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(EditTLMApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(EditTLMApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});

export const EditTLMreducer = EditTLMSlice.reducer;
